import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ButtonLoaderStateService } from './button-loader-state.service';
import { finalize } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ButtonLoaderInterceptorService implements HttpInterceptor {
  constructor(private buttonLoaderStateService: ButtonLoaderStateService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.headers.has('withButtonLoader')) {
      const newHeaders = req.headers.delete('withButtonLoader');
      req = req.clone({ headers: newHeaders });

      this.buttonLoaderStateService.startLoader(req.url);

      return next.handle(req).pipe(
        finalize(() => {
          this.buttonLoaderStateService.stopLoader(req.url);
        })
      );
    }

    return next.handle(req);
  }
}
